import { useState } from 'react';
import type { CalculatorFormData, StepConfig } from '../calculatorTypes';
import { YesNoToggle } from '../shared/YesNoToggle';
import { getText } from '../calculatorUtils';
import type { CalcTexts } from '../locales';
import styles from '../Calculator.module.css';

interface Props {
  step: StepConfig;
  formData: CalculatorFormData;
  onNext: (data: Partial<CalculatorFormData>) => void;
  onBack: (data: Partial<CalculatorFormData>) => void;
  canGoBack: boolean;
  texts: CalcTexts;
}

export function YesNoStep({ step, formData, onNext, onBack, canGoBack, texts }: Props) {
  const key = step.saveKey as keyof CalculatorFormData;
  const [value, setValue] = useState<boolean>((formData[key] as boolean) ?? false);

  const useAlt =
    step.questionKeyAltCondition &&
    formData[step.questionKeyAltCondition as keyof CalculatorFormData] === true;

  const question =
    useAlt && step.questionKeyAlt
      ? getText(texts, step.questionKeyAlt)
      : getText(texts, step.questionKey!);

  const hintText = step.hintKey ? getText(texts, step.hintKey) : undefined;

  return (
    <div className={styles.stepContent}>
      <p className={styles.stepQuestion}>{question}</p>
      <YesNoToggle
        value={value}
        onChange={setValue}
        labelYes={getText(texts, 'common.buttons.yes')}
        labelNo={getText(texts, 'common.buttons.no')}
        aria-label={question}
      />

      {hintText && <div className={styles.hintBox}>{hintText}</div>}

      <div className={styles.stepNav}>
        <button
          type="button"
          className={styles.btnBack}
          onClick={() => onBack({ [key]: value } as Partial<CalculatorFormData>)}
          disabled={!canGoBack}
        >
          {'< '}{texts.common.buttons.back}
        </button>
        <button
          type="button"
          className={styles.btnSecondary}
          onClick={() => onNext({ [key]: value } as Partial<CalculatorFormData>)}
        >
          {texts.common.buttons.continue}
        </button>
      </div>
    </div>
  );
}
